import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector,reset } from "redux-form";
import Multiselect from 'react-widgets/lib/Multiselect'

import {  Card, CardBody, Button, Spinner, CardTitle,Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from "react-redux";
import Banner from "../common/banner";
import {renderCheckbox} from "../common/renderinput"
import axios from "axios";
import appConfig from '../../config/config';

const divStyle = {
    backgroundColor: '#fff'
};
const padStyle = {
    paddingTop: '5px', paddingLeft : '0px'
};
const diagStyle = {
    width: '897px', height:'802px'
}
const renderMultiselect = ({ input, data, disabled, valueField, textField }) =>
    <Multiselect {...input}
        onBlur={() => input.onBlur()}
        value={input.value || []} // requires value to be an array
        data={data}
        valueField={valueField}
        textField={textField}
        disabled={disabled}
    />
    const pcrData = [
      'PCR Exterior Residential  '];
class AddProductForm extends Component {

    constructor(...args) {
        super(...args);
        this.state = {
            showBanner: false, message: '', activeTab: '1', 
            Loading: false, 
            data: [], display:true, 
            isSuccess:false,
            product:[]
        };
    }
    closeBanner = () => {
        this.setState({
            showBanner: false, message: ''
        });
    };
    toggle = (val) => {
        this.setState({...this.state, display : !val})
    }
    loadData=()=>{
    //download products
    axios.post(
      appConfig.apiGateway.searchUrl,
      JSON.stringify({ User: this.props.session.Role.email, Action: "PRODUCT" }),
      {
          headers: {
              'Content-Type': 'application/json'
          }
      }
  ).then(response => {

    var prodlist = JSON.parse(response.data.body).filter(p=>(p.GROUP == 'APP' || p.GROUP == 'TITLE')).map(q=>{ return q.PRODUCT })
    this.setState({
      ...this.state, product: prodlist
    });

  }, error => {
            console.log(error)});
    }
    componentDidMount() {
      console.log("AddProductForm")
      this.loadData()
    }
    submit = (values) => {
      this.setState({...this.state, Loading : true})
        axios.post(
            appConfig.apiGateway.updateOrderUrl,
            JSON.stringify({
                ...values, OrderId: this.props.OrderId,
                Action: "AddProduct",
                UserName: this.props.session.session.user.name
            }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then((response) => { 
                  this.setState({...this.state, Loading : false})
                if (!(response.hasOwnProperty('data') && response.data.hasOwnProperty('body')))
                {
                    this.setState({ ...this.state, message: 'Invalid response', 
                    showBanner: true })
                    return;
                }
                //var myObject = JSON.parse(response.data.body);
                if (response.data.body.status) {
                    this.props.showBanner(values['OrderProductId'] + ' Added')
                    this.props.Add(false)
                    return;
                }
                else {
                    this.setState(state => ({ ...state, message: response.data.body.message, 
                      showBanner: true }));
                }

            },
            (error) => {
                this.setState(state => ({ ...state, message: error, showBanner: true, Loading : false }));

            });
       
    }
    componentDidMount() {
    }
    Hide=()=> {
      this.props.Add(false)  
      //this.setState({...this.state, display:false})
    }
    render() {
        return (
          <>
            <div>
              <Modal
                //show={this.state.display}
                onHide={()=>this.Hide}
                 isOpen={this.state.display}
                 toggle={this.toggle}
                contentClassName="custom-modal-style"
              >
                <form
                  onSubmit={this.props.handleSubmit(this.submit)}
                  style={{ marginLeft: "0%", marginRight: "5%" }}
                >
                  <ModalHeader>Add Product</ModalHeader>
                  <ModalBody>
                    {this.state.showBanner && (
                      <Banner
                        Close={this.closeBanner}
                        message={this.state.message}
                        IsSuccess={this.state.isSuccess}
                      />
                    )}
                    <div className="form-row col-12" style={padStyle}>
                      <div className="col-12" style={divStyle}>
                      <Field
                            name="OrderProductId"
                            component={renderMultiselect}
                            defaultValue={[]}
                            data={this.state.product} />
                      </div>
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" type="submit">
                      {this.state.Loading && <Spinner />}
                      {!this.state.Loading && <span>Save</span>}
                    </Button>
                    <Button
                      color="secondary"
                      onClick={() => this.Hide()}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </form>
              </Modal>
            </div>
          </>
        );
    }

}
const validate = (formValues) => {
    const errors = {};
    if (!formValues.PCR) {
        errors.PCR = "Please Select PCR ";
    }
    return errors;
}
var addProductForm = reduxForm({
    form: 'addProductForm',
    validate
})(AddProductForm);

addProductForm = connect(
    state => ({
        session: state.session
    })
)(addProductForm);

export default addProductForm;